import { showFile } from "../helpers/utils";
import { service } from "./../server/request";
export const getCatererSummaryData = async (reqData) => {
  try {
    const { catererId, menuType: type, startYearMonth, endYearMonth } = reqData;
    const url = `/mealManage/catererCalendarSummaries/search/findByCatererAndTypeAndMonths?itemType=${type}&catererId=${catererId}&startYearMonth=${startYearMonth}&endYearMonth=${endYearMonth}`;
    const resp = await service({
      method: "GET",
      url: url,
    });
    if (resp.status === 200) {
      return { success: true, data: resp.data };
    }
  } catch (ex) {
    return { error: true, errorMessage: ex.message };
  }
};
export const getMasterMenuItems = async (reqData) => {
  const { schoolId, type } = reqData;
  try {
    const url = `mealManage/menuItems/search/findMenuItemsBySchool?schoolId=${schoolId}&types=${type}`;
    const resp = await service({
      method: "GET",
      url: url,
    });
    if (resp.status === 200) {
      return { success: true, data: resp.data };
    }
  } catch (ex) {
    return { error: true, errorMessage: ex.message };
  }
};
export const getAllergiesByIngredients = async (reqData) => {
  try {
    const url = `mealManage/allergens`;
    const resp = await service({
      method: "POST",
      url: url,
      data: reqData,
    });
    if (resp.status === 200) {
      return { success: true, data: resp.data };
    }
  } catch (ex) {
    return { error: true, errorMessage: ex.message };
  }
};
export const CloneMenu = async (reqData, id) => {
  try {
    const url = `/mealManage/caterer/cloneCalendar/${id}`;
    const resp = await service({
      method: "PUT",
      url: url,
      data: reqData,
    });
    if (resp.status === 200) {
      return { success: true, data: resp.data };
    }
  } catch (ex) {
    return { error: true, errorMessage: ex.message };
  }
};
export const addMasterMenuItem = async (reqData) => {
  try {
    const url = `mealManage/menuItems`;
    const resp = await service({
      method: "POST",
      url: url,
      data: reqData,
    });
    if (resp.status === 201) {
      return { success: true, data: resp.data };
    }
  } catch (ex) {
    return { error: true, errorMessage: ex.message };
  }
};
export const updateMasterMenuItem = async (reqData, menuItemId) => {
  try {
    const url = `mealManage/menuItems/${menuItemId}`;
    const resp = await service({
      method: "PATCH",
      url: url,
      data: reqData,
    });
    if (resp.status === 200) {
      return { success: true, data: resp.data };
    }
  } catch (ex) {
    return { error: true, errorMessage: ex.message };
  }
};
export const addSubCategory = async (reqData, menuItemId) => {
  const url = `mealManage/itemSubCategories`;
  const resp = await service({
    method: "POST",
    url: url,
    data: reqData,
  });
  if (resp.status === 200) {
    return { success: true, data: resp.data };
  }
};
export const getAllSubCategories = async (catererId, category) => {
  const url = `mealManage/itemSubCategories/search/findMenuItemsSubCategories?catererId=${catererId}&category=${category}`;
  const resp = await service({
    method: "GET",
    url: url,
  });
  if (resp.status === 200) {
    return { success: true, data: resp.data };
  }
};
export const updateMenuItem = async (reqData, menuItemId) => {
  try {
    const url = `mealManage/menuCaterers/${menuItemId}`;
    const resp = await service({
      method: "PATCH",
      url: url,
      data: reqData,
    });
    if (resp.status === 200) {
      return { success: true, data: resp.data };
    }
  } catch (ex) {
    return { error: true, errorMessage: ex.message };
  }
};
export const updateMenuItem_new = async (reqData, menuItemId, source) => {
  try {
    const url = source === "schoolMenu" ? `mealManage/menuItems/${menuItemId}` : `mealManage/menuCaterers/${menuItemId}`;
    return service({
      method: "PATCH",
      url: url,
      data: reqData,
    });
  } catch (ex) {
    return { error: true, errorMessage: ex.message };
  }
};
export const addMenuItem_new = async (reqData, menuItemId) => {
  try {
    const url = `mealManage/menuCaterers`;
    return service({
      method: "POST",
      url: url,
      data: reqData,
    });
  } catch (ex) {
    return { error: true, errorMessage: ex.message };
  }
};
export const getAllCatererItem = async () => {
  try {
    const url = `mealManage/menuCaterers`;
    const resp = await service({
      method: "GET",
      url: url,
    });
    if (resp.status === 200) {
      return { success: true, data: resp.data };
    }
  } catch (ex) {
    return { error: true, errorMessage: ex.message };
  }
};
export const getAllMasterMenuItem = async (catererID, mtype, isActive = true, nutritionAnalysis = false) => {
  try {
    let types = [];
    let _mtype = mtype;
    if (_mtype == "LUNCH") {
      _mtype = "MEAL";
    }
    let mealType = "MEAL";
    if (nutritionAnalysis) {
      types = [_mtype, "ENTREE", "GRAINS", "FRUIT", "MILK", "VEGETABLES", "SIDE", "EXTRA", "MISCELLANEOUS"];
      mealType = mtype;
    } else {
      mealType = mtype;
      types = [_mtype, "ENTREE", "SIDE", "EXTRA", "MISCELLANEOUS"];
    }

    const url = `mealManage/menuCaterers/search/findActiveMenuItemsByCatererAndTypes?catererId=${catererID}&types=${types.join(
      ","
    )}&mealCategory=${mealType},SIDE,EXTRA&isActive=${isActive}`;
    const resp = await service({
      method: "GET",
      url: url,
    });
    if (resp.status === 200) {
      return { success: true, data: resp.data };
    }
  } catch (ex) {
    return { error: true, errorMessage: ex.message };
  }
};
export const getAllMasterMenuItemBySchool = async (schoolID, calendarSummaryId, isActive = true) => {
  try {
    //const url=`mealManage/menuItems/search/findActiveMenuItemsBySchoolAndTypes?schoolId=${schoolID}&types=MEAL,SIDE,EXTRA`;
    const url = `mealManage/getSchoolMenus/${schoolID}/${calendarSummaryId}?isActive=${isActive}`;
    const resp = await service({
      method: "GET",
      url: url,
    });
    if (resp.status === 200) {
      return { success: true, data: resp.data };
    }
  } catch (ex) {
    return { error: true, errorMessage: ex.message };
  }
};
export const getCatererMenuDataByID = async (id, isCatererMenu) => {
  try {
    const url = `mealManage/monthlyCalendars/${id}?isCatererMenu=${isCatererMenu}`;
    const res = await service({
      method: "GET",
      url: url,
    });
    if (res.status === 200) {
      const { resp } = res.data;
      let _recurringDays = {};
      Object.keys((resp || {}).recurringDays || {}).map((keyName) => {
        if (keyName == "MAINCOURSE") {
          _recurringDays["ENTREE"] = ((resp || {}).recurringDays || {})[keyName] || [];
        } else {
          _recurringDays[keyName] = ((resp || {}).recurringDays || {})[keyName] || [];
        }
      });
      resp.recurringDays = _recurringDays;

      return { success: true, data: { ...res.data, resp } };
    }
  } catch (ex) {
    return { error: true, errorMessage: ex.message };
  }
};
export const updateMenuFromSchool = async (reqData, calendarSummaryId) => {
  try {
    const url = `/mealManage/schoolMonthlyCalendar/${calendarSummaryId}`;
    const resp = await service({
      method: "PUT",
      url: url,
      data: reqData,
    });
    if (resp.status === 200) {
      return { success: true, data: resp.data };
    }
  } catch (ex) {
    return { error: true, errorMessage: ex.statusMessage || ex.message };
  }
};
export const createMenu = async (reqData, catererId, calendarSummaryId) => {
  try {
    const url = `/mealManage/catererMonthlyCalendar/${catererId}/${calendarSummaryId}`;
    const resp = await service({
      method: "POST",
      url: url,
      data: reqData,
    });
    if (resp.status === 200) {
      return { success: true, data: resp.data };
    }
  } catch (ex) {
    return { error: true, errorMessage: ex.errorMessage || ex.message || ex.statusMessage };
  }
};
export const createUpdateMenuList = async (reqData, catererMenuId) => {
  try {
    const url = `/mealManage/menuCaterers/${catererMenuId}`;
    const resp = await service({
      method: "PATCH",
      url: url,
      data: reqData,
    });
    if (resp.status === 200) {
      return { success: true, data: (resp.data || {}).resp || [] };
    }
  } catch (ex) {
    return { error: true, errorMessage: ex.errorMessage || ex.message };
  }
};
export const createUpdateSchoolMenuList = async (reqData, schoolId) => {
  try {
    const url = `/mealManage/school/${schoolId}/masterMenu`;
    const resp = await service({
      method: "POST",
      url: url,
      data: reqData,
    });
    if (resp.status === 200) {
      return { success: true, data: (resp.data || {}).resp || [] };
    }
  } catch (ex) {
    return { error: true, errorMessage: ex.errorMessage || ex.message };
  }
};
export const menuscopyToSchool = async (schoolIds = [], calendarSummaryId) => {
  try {
    const url = `/mealManage/caterer/copyCalendar/${calendarSummaryId}?schoolIds=${schoolIds.join(",")}`;
    const resp = await service({
      method: "PUT",
      url: url,
    });
    if (resp.status === 200) {
      return { success: true, data: resp.data };
    }
  } catch (ex) {
    return { error: true, errorMessage: ex.errorMessage || ex.message };
  }
};

export const deleteMasterMenuItem = async (id) => {
  try {
    const url = `/mealManage/catererCalendar/${id}`;
    const resp = await service({
      method: "DELETE",
      url: url,
    });
    if (resp.status === 200) {
      return { success: true, data: resp.data };
    }
  } catch (ex) {
    return { error: true, errorMessage: ex.errorMessage || ex.message || ex.statusMessage };
  }
};
export const getMenuMappedSchools = async (mealSummaryId) => {
  try {
    const url = `/mealManage/copyTo/applicableSchools/${mealSummaryId}`
    //const url = `/mealManage/mappedMenuSchools/${mealSummaryId}`;
    const resp = await service({
      method: "GET",
      url: url,
    });
    if (resp.status === 200) {
      return { success: true, data: resp.data.resp };
    }
  } catch (ex) {
    return { error: true, errorMessage: ex.errorMessage };
  }
};
export const fetchMealPrograms = async () => {
  try {
    const url = `mealManage/meal-programs`;
    const resp = await service({
      method: "GET",
      url: url,
    });
    if (resp.status === 200) {
      return { success: true, data: resp.data };
    }
  } catch (ex) {
    return { error: true, errorMessage: ex.message };
  }
};
export const getAnalysisData = async (payload) => {
  try {
    const url = `mealManage/menu-analysis`;
    const resp = await service({
      method: "POST",
      url: url,
      data: payload,
    });
    if (resp.status === 200) {
      let data = [];
      if (payload.rule == "WEEKLY") {
        const { weeks } = resp.data;
        (weeks || []).map(week => {
          if ((week.results || []).length > 0) {
            data.push(week);
          } else {
            if ((week.days || []).length <= 2 && (week.days || []).length > 0) {
              data.push({ ...week, results: week.days[0].results, days: undefined });
            } else {
              data.push(week);
            }
          }
        })
      } else {
        const { weeks } = resp.data;
        data = weeks;
      }
      return { success: true, data: { ...resp.data, weeks: data } };
    }
  } catch (ex) {
    return { error: true, errorMessage: ex.message };
  }
};

export const getNutritionAnalysisByPlaned = async (payload) => {
  try {
    const url = `mealManage/nutrition-planner`;
    const resp = await service({
      method: "POST",
      url: url,
      data: payload,
    });
    if (resp.status === 200) {
      return { success: true, data: resp.data };
    }
  } catch (ex) {
    return { error: true, errorMessage: ex.message };
  }
}
export const getNutritionAnalysisPdf = async (reqBody, filename) => {
  try {
    const url = `mealManage/menuNutritionAnalyze/print`;
    const resp = await service({
      method: 'POST',
      url: url,
      data: reqBody,
      responseType: "blob"
    });
    if (resp.status === 200) {
      await showFile(resp.data, filename);
      return { success: true, data: resp.data };
    }
  } catch (ex) {
    return { error: true, errorMessage: ex.message }
  }
}
export const getMealPatternPdf = async (reqBody, filename, catererId) => {
  try {
    const url = `mealManage/exportMealPattern/${catererId}`;
    const resp = await service({
      method: 'POST',
      url: url,
      data: reqBody,
      responseType: "blob"
    });
    if (resp.status === 200) {
      await showFile(resp.data, filename);
      return { success: true, data: resp.data };
    }
  } catch (ex) {
    return { error: true, errorMessage: ex.message }
  }
}
export const getSavedPlannedPreparedData = async (menuSummaryId) => {
  try {
    const url = `mealManage/MenuAnalysisItems/search/findByMenuSummaryId?menuSummaryId=${menuSummaryId}`;
    const resp = await service({
      method: "GET",
      url: url,
    });
    if (resp.status === 200) {
      return { success: true, data: resp.data };
    }
  } catch (ex) {
    return { error: true, errorMessage: ex.message };
  }

}

export const saveNutritonAnalysisData = async (reqBody) => {
  try {
    const url = `mealManage/MenuAnalysisItems`;
    const resp = await service({
      method: "POST",
      url: url,
      data: reqBody,
    });
    if (resp.status === 201) {
      return { success: true, data: resp.data };
    }
  } catch (ex) {
    return { error: true, errorMessage: ex.message };
  }
}
export const updateNutritonAnalysisData = async (reqBody, id) => {
  try {
    const url = `mealManage/MenuAnalysisItems/${id}`;
    const resp = await service({
      method: "PUT",
      url: url,
      data: reqBody,
    });
    if (resp.status === 200) {
      return { success: true, data: resp.data };
    }
  } catch (ex) {
    return { error: true, errorMessage: ex.message };
  }
}